import { EdgeGetSignatureRequestStatusRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { GetSignatureRequestStatus } from '@/modules/auth/use-cases'

export function makeGetSignatureRequestStatus(): GetSignatureRequestStatus {
  return new EdgeGetSignatureRequestStatusRepository(makeSupabaseEdgeHttpClient()).execute
}
